/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable react/prop-types */
import React from 'react';
import clsx from 'clsx';
import Chip from '@material-ui/core/Chip';
import Button from 'components/Button';
import { Input, Select, Radio, UploadFile } from 'components/Form';
import classes from './Elements.module.scss';

export const FormItem = ({ className, children }) => {
  return <div className={clsx(classes.formItem, className)}>{children}</div>;
};
export const Box = ({ className, children }) => {
  return <div className={clsx(classes.box, className)}>{children}</div>;
};
export const Title = ({ className, children }) => {
  return <div className={clsx(classes.title, className)}>{children}</div>;
};
export const Label = ({ className, children }) => {
  return <label className={clsx(classes.label, className)}>{children}</label>;
};
export const StyledButton = ({ className, children, link, ...other }) => {
  const { buttonProps } = other;
  return (
    <Button
      buttonProps={{
        ...buttonProps,
        className: clsx(
          classes.styledButton,
          {
            [classes.link]: link,
          },
          className
        ),
      }}>
      {children}
    </Button>
  );
};
export const StyledInput = ({ className, type, errorIconCenter, ...other }) => {
  return (
    <Input
      inputProps={{
        ...other,
        className: clsx(
          classes.styledInput,
          {
            [classes.errorIconCenter]: errorIconCenter,
          },
          className
        ),
      }}
      type={type}
    />
  );
};
export const StyledSelect = ({ className, ...other }) => {
  return (
    <Select
      selectProps={{
        ...other,
        className: clsx(classes.styledSelect, className),
      }}
    />
  );
};
export const StyledRadio = ({ wrapperClassName, className, ...other }) => {
  return (
    <Radio
      radioProps={{
        ...other,
        className: clsx(classes.styledRadio, className),
      }}
      className={clsx(classes.styledRadioWrapper, wrapperClassName)}
    />
  );
};
export const StyledTag = ({ className, isSelected, small, ...other }) => {
  return (
    <Chip
      {...other}
      className={clsx(
        classes.styledTag,
        {
          [classes.isSelected]: isSelected,
          [classes.small]: small,
        },
        className
      )}
    />
  );
};
export const StyledUploadFile = ({
  className,
  description = 'Support: JPG, JPEG, PNG',
  btnText,
  hideErrAfter3s,
  fileListClassName,
  uploadDocument,
  viewImage, viewDocument,
  ...other
}) => {
  return (
    <UploadFile
      inputProps={{
        ...other,
        className: clsx(classes.styledUploadFile, className),
        buttonProps: {
          btnText: btnText || (
            <div className={classes.uploadPlaceholder}>
              <h4>Drop your file here, or Browse</h4>
              <p>{description}</p>
            </div>
          ),
        },
      }}
      hideErrAfter3s={hideErrAfter3s}
      fileListClassName={fileListClassName}
      uploadDocument={uploadDocument}
      viewImage={viewImage}
      viewDocument={viewDocument}
    />
  );
};
